import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';

export const Home = () => {
  return (
    <div className="page-wrapper">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};
